import type {JSONValue} from 'types';
import {getOffset} from 'services/utils/getOffset';
import type {AgentWorksSearchProps, SearchProps} from '../types';
import agentWorksQuery from '../data/agentWorksQuery.json';

const WORK_INDEX = 'ebs-work-alias';

export const mapAgentWorksSearchPropsToSearchProps = ({
  agentId,
  page,
  size,
  abortSignal,
}: AgentWorksSearchProps): SearchProps => {
  const from = getOffset(page, size);

  const elasticBody = JSON.parse(
    JSON.stringify(agentWorksQuery)
      .replaceAll('${QUERY_PLACEHOLDER}', agentId)
      .replaceAll('"${FROM_PLACEHOLDER}"', String(from))
      .replaceAll('"${SIZE_PLACEHOLDER}"', String(size)),
  ) as JSONValue;

  return {
    target: '_search',
    index: WORK_INDEX,
    elasticBody,
    abortSignal,
  };
};
